

































































































































































































import { Component, Vue } from "vue-property-decorator";
import BookH from "../components/book-h.vue";
import BookV from "../components/book-v.vue";
import Publish from "../components/publish.vue";
import indexService from "../service/indexService";
import bookService from "../service/bookService";
import audioService from "../service/audioService";
import HeaderNav from "../components/header-nav.vue";
import utils from "@/utils";

@Component({
  components: { BookH, BookV, Publish, HeaderNav }
})
export default class Index extends Vue {
  private name: string = "index";
  private bannerList: any[] = []; // 轮播图
  private activitiesList: any[] = []; // 精彩活动

  private loopOk: boolean = false;
  private radiusDot0: boolean = false;
  private radiusDot1: boolean = false;
  private bookData: any[] = [];
  private listenData: any[] = [];
  private bookRankData: any[] = []; // 图书排行
  private audioRankData: any[] = []; // 听书排行
  private publisherData: any[] = []; // 合作出版社
  private orgData: any[] = []; // 合作机构

  private authorList: any[] = [];
  private casesList: any[] = [];
  private newsList: any[] = [];
  private publishLen: number = 0;
  private orgLen: number = 0;
  private data() {
    return {
      arrow: "never",
      initIndex: 0,
      autoplaySpeed: 3000
    };
  }
  private created() {
    // 获取轮播图
    indexService.getBanners().then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        this.bannerList = result.list;
        for(let obj of this.bannerList){ 
          if(obj.imgUrl && obj.imgUrl.length >0){ //图片请求头协议与访问地址保持一致
            obj.imgUrl = obj.imgUrl.replace(/.+(?=\/\/)/i ,window.location.protocol);
          }
          if(obj.url.substring(0,14) =="/static-topic/"){//以相对地址开头的专题地址，地址访问https://shuxiang.chineseall.cn/
              obj.url="https://shuxiang.chineseall.cn"+obj.url;
          }
        }  
        //console.log("this.bannerList:",this.bannerList);
        if (this.bannerList.length > 1) {
          this.loopOk = true;
        }
      }
      if (!result.success) {
        this.$Message.error("数据获取失败!");
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

    // 获取精彩活动
    this.activitiesList = [
      // {
      //   id: 1,
      //   title: "用书香建设校园，用文字传递真情，让阅读成为师生们的一种追求、一种爱好、一种健康的生活方式。",
      //   url: "http://sxahtgw.chineseall.cn/activity/show/25440/1/1/0",
      //   publish: "2019-12-01",
      //   imgUrl: "http://imgb2.chineseall.cn/yunping/banner/BOOK_WEB/BOOK_WEB_70.jpeg"
      // },
      // {
      //   id: 2,
      //   title: "阅读带你穿越北京中轴线，知识竞赛带你感受中国千年文化脉搏",
      //   url: "http://www.chineseall.cn/static-topic/sxdczzxp/prize_pc.html",
      //   publish: "2019-04-22",
      //   imgUrl: "http://imgb2.chineseall.cn/yunping/banner/BOOK_WEB/BOOK_WEB_9.png"
      // },
      // {
      //   id: 3,
      //   title: "4·23世界读书日，于字里行间，体验阅读的魅力",
      //   url: "http://www.chineseall.cn/static-topic/190423/423_pc.html",
      //   publish: "2019-04-23",
      //   imgUrl: "http://imgb2.chineseall.cn/yunping/banner/BOOK_WEB/BOOK_WEB_34.jpeg"
      // }
      // {
      //   id: 1,
      //   title: "春暖书香景明，巾帼芳华正茂",
      //   url: "https://shuxiang.chineseall.cn/static-topic/20230308/index_pc.html",
      //   publish: "2023-03-08",
      //   imgUrl:
      //     "https://sx-imgs.oss-cn-zhangjiakou.aliyuncs.com/pc/banner/2023/05/09/www_3.jpg",
      // },
      // {
      //   id: 2,
      //   title: "护苗2023，绿书签活动",
      //   url: "https://shuxiang.chineseall.cn/static-topic/2023_hm/index_pc.html",
      //   publish: "2023-05-22",
      //   imgUrl:
      //     "https://sx-imgs.oss-cn-zhangjiakou.aliyuncs.com/pc/banner/2023/05/31/www_1.jpg",
      // },
      // {
      //   id: 3,
      //   title: "翰墨飘香庆端午",
      //   url: "https://shuxiang.chineseall.cn/static-topic/2023_0505/index_pc.html",
      //   publish: "2023-06-22",
      //   imgUrl:
      //     "https://sx-imgs.oss-cn-zhangjiakou.aliyuncs.com/pc/banner/2023/05/31/www_2.jpg",
      // },
       {
        id: 1,
        title: "百年征程·光影筑梦新时代",
        url: "https://shuxiang.chineseall.cn/static-topic/2025/71/index_pc/index.html",
        publish: "2025-07-01",
        imgUrl:
          "https://sx-imgs.oss-cn-zhangjiakou.aliyuncs.com/pc/banner/2025/bnzc/690-250.jpg",
      },
        {
        id: 1,
        title: "粽香诗韵，端午情长",
        url: "https://shuxiang.chineseall.cn/static-topic/2025/55/index_pc/index.html",
        publish: "2025-05-30",
        imgUrl:
          "https://sx-imgs.oss-cn-zhangjiakou.aliyuncs.com/pc/banner/2025/dwj/690-250.jpg",
      },
      {
        id: 2,
        title: "以墨传情·致敬平凡之光",
        url: "https://shuxiang.chineseall.cn/static-topic/2025/51/index_pc/index.html",
        publish: "2025-05-01",
        imgUrl:
          "https://sx-imgs.oss-cn-zhangjiakou.aliyuncs.com/pc/banner/2025/ldj/690-250.jpg",
      },
      //  {
      //   id: 3,
      //   title: "智启未来：当阅读遇见AI",
      //   url: "https://shuxiang.chineseall.cn/static-topic/2025/423_ai/index_pc/index.html",
      //   publish: "2025-04-23",
      //   imgUrl:
      //     "https://sx-imgs.oss-cn-zhangjiakou.aliyuncs.com/pc/banner/2025/mls/690-250.jpg",
      // },
     
      //,
      // {
      //   id: 4,
      //   title: "新年新气象 元旦接好运",
      //   url: "https://shuxiang.chineseall.cn/static-topic/2025/0101/index_pc.html",
      //   publish: "2025-01-01",
      //   imgUrl:
      //     "https://sx-imgs.oss-cn-zhangjiakou.aliyuncs.com/pc/banner/2025/3.jpg",
      // },
    ];
    for (const activities of this.activitiesList) {
      const str = activities.publish.split("-");
      activities.day = str[2];
      activities.yearMonth = str[0] + "." + str[1];
      if (activities.title && activities.title.length > 32) {
        activities.title = utils.isSubstring(activities.title, 32) + '...';
      }
    }

    // 出版图书
    bookService.getPublishBook(8).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        for (const item of result.list) {
          item.url = "http://shuxiang.chineseall.cn/book/detail/" + item.shId;
          if (item.intro && item.intro.length > 20) {
            item.intro = utils.isSubstring(item.intro, 20) + '...';
          }
        }
        this.bookData = result.list;
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

    // 图书榜
    bookService.getBookRanks(10).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        if (result.list.length > 5) {
          this.radiusDot0 = true;
        }
        result.list.forEach((item: any, i: any) => {
          item.rank = i + 1;
          item.url = "http://shuxiang.chineseall.cn/book/detail/" + item.shId;
        });
        this.bookRankData = Vue.$utils.arrayToTwoArray(result.list, 5);
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

    // 有声听书
    audioService.getAudioData(8).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        for (const item of result.list) {
          //item.url = "http://shuxiang.chineseall.cn/book/audio/" + item.id;
          item.url = "http://shuxiang.chineseall.cn/audio/play/" + item.id;
          if (item.intro && item.intro.length > 20) {
            item.intro = utils.isSubstring(item.intro, 20) + '...';
          }
        }
        this.listenData = result.list;
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

    // 听书榜
    audioService.getAudioRanks(10).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        if (result.list.length > 5) {
          this.radiusDot1 = true;
        }
        result.list.forEach((item: any, i: any) => {
          item.rank = i + 1;
          item.url = "http://shuxiang.chineseall.cn/audio/play/" + item.id;
        });
        this.audioRankData = Vue.$utils.arrayToTwoArray(result.list, 5);
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

    // 合作出版社
    indexService.getPublisher(16).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        this.publishLen = result.list.length;
        this.publisherData = Vue.$utils.arrayToTwoArray(result.list, 8);
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

    // 合作机构
    indexService.getOrgList(16).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        this.orgLen = result.list.length;
        this.orgData = Vue.$utils.arrayToTwoArray(result.list, 8);
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

    // 名家作者
    indexService.getAuthorList(8).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        this.authorList = result.list;
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

    // 成功案例
    indexService.getCaseList(4).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        for (const item of result.list) {
          if (item.title && item.title.length > 40) {
            item.title = utils.isSubstring(item.title, 40) + '...';
          }
        }
        this.casesList = result.list;
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });

    // 新闻媒体
    indexService.getNewsList(5).then((result: any) => {
      if (result.success && result.list && result.list.length > 0) {
        this.newsList = result.list;
        for (const item of result.list) {
          item.create = this.changeTime(item.create);
          if (item.title && item.title.length > 48) {
            item.title = utils.isSubstring(item.title, 48) + '...';
          }
        }
      }
    }).catch((err: any) => {
      this.$Message.error("数据获取失败!");
    });
  }
  private mounted() {
    this.$forceUpdate();
    window.addEventListener("scroll", this.handleScroll, true);
  }

  private handleScroll() {
    let scrollTop = 0;
    if (document.documentElement && document.documentElement.scrollTop) {
      scrollTop = document.documentElement.scrollTop;
    } else if (document.body) {
      scrollTop = document.body.scrollTop;
    }
    if (scrollTop > 8) {
      if ((this.$refs.headerNavFixed as HTMLDivElement)) {
        (this.$refs.headerNavFixed as HTMLDivElement).style.display = 'block';
        (this.$refs.headerNavIndexFixed as HTMLDivElement).style.display = 'none';
      }
    } else {
      if ((this.$refs.headerNavFixed as HTMLDivElement)) {
        (this.$refs.headerNavFixed as HTMLDivElement).style.display = 'none';
        (this.$refs.headerNavIndexFixed as HTMLDivElement).style.display = 'block';
      }
    }
  }

  private changeTime(time: string) {
    const str = time.split(' ')[0].split('-');
    return str[0] + '年' + str[1] + '月' + str[2] + '日';
  }
}
